import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Task } from '../types'

export const TaskMeta = ({ id, created_by, created_at }: Task) => {
  const { t } = useTranslation()

  return (
    <span>
      {`#${id} ${t('common.opened')} ${created_at}`}
      {created_by && (
        <>
          {t('common.by')}
          <Link to="#">
            {created_by.first_name} {created_by.last_name}
          </Link>
        </>
      )}
    </span>
  )
}
